export interface CommonTemplateProps {
  page: React.FunctionComponent;
}

export default function CommonTemplate({ page: Page }: CommonTemplateProps) {
  return (
    <div className="flex h-screen bg-background">
      <div className="flex-1 flex flex-col overflow-y-auto">
        <Page />
      </div>
    </div>
  );
}
